import { createContext, useContext, useReducer, useMemo, useState, useCallback } from 'react';

const AppStateContext = createContext();

const appReducer = (state, action) => {
    switch (action.type) {
        case 'SET_COURSES':
            return { ...state, courses: action.payload };
        case 'SET_TEACHER_ATTENDANCE':
            return { ...state, teacherAttendance: action.payload };
        case 'SET_STUDENT_ATTENDANCE':
            return { ...state, studentAttendance: action.payload };
        case 'SET_UNIQUE_STUDENT_COUNT':
            return { ...state, uniqueStudentCount: action.payload };
        case 'SET_PENDING_ACTIONS':
            return { ...state, pendingActions: action.payload };
        case 'SET_LOADING':
            return { ...state, loading: action.payload };
        case 'SET_MANAGED_CLUBS':
            return { ...state, managed_clubs: action.payload };
        case 'SET_CLASS_TEACHER':
            return { ...state, is_class_teacher: action.payload };
        case 'SET_HOD':
            return { ...state, is_hod: action.payload };
        case 'SET_HOS':
            return { ...state, is_head_of_studies: action.payload };
        case 'SET_PRINCIPAL':
            return { ...state, is_principal: action.payload };
        case 'SET_PERFORMANCE_BANDS':
            return { ...state, performanceBands: action.payload };
        case 'SET_TOAST':
            return { ...state, toast: action.payload };
        case 'CLEAR_TOAST':
            return { ...state, toast: null };
        case 'CLEAR_STATE':
            return { courses: [], teacherAttendance: [], studentAttendance: [], managed_clubs: [], is_class_teacher: false, is_hod: false, is_head_of_studies: false, is_principal: false, uniqueStudentCount: 0, pendingActions: [], loading: false, error: null, toast: null, performanceBands: [] };
        default:
            return state;
    }
};

export const AppStateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, {
        courses: [],
        teacherAttendance: [],
        studentAttendance: [],
        managed_clubs: [],
        is_class_teacher: false,
        is_hod: false,
        is_head_of_studies: false,
        is_principal: false,
        uniqueStudentCount: 0,
        pendingActions: [],
        loading: false,
        error: null,
        toast: null,
        performanceBands: [],
    });

    const [needsRefresh, setNeedsRefresh] = useState(true);

    const refresh = useCallback(() => {
        setNeedsRefresh(true);
    }, []);

    const showToast = useCallback((message, type = 'success') => {
        dispatch({ type: 'SET_TOAST', payload: { message, type } });
        setTimeout(() => {
            dispatch({ type: 'CLEAR_TOAST' });
        }, 3000);
    }, []);

    const value = useMemo(
        () => ({ ...state, dispatch, refresh, needsRefresh, setNeedsRefresh, showToast }),
        [state, needsRefresh, refresh, showToast]
    );

    return <AppStateContext.Provider value={value}>{children}</AppStateContext.Provider>;
};

export const useAppState = () => useContext(AppStateContext);